export const ROLES = {
  CLINICAL_MENTOR_HEB: '10',
  EMOTIONAL_MENTOR_HEB: '11',
  CLINICAL_MENTOR_EN: '20',
  EMOTIONAL_MENTOR_EN: '21',
  DEFAULT_MENTOR: '22',
  SUPERVISOR: '30',
  TECH_ADMIN: '40',
  MANAGEMENT_ADMIN: '41',
} as const;

export const ADMIN_ROLES = [ROLES.SUPERVISOR, ROLES.TECH_ADMIN, ROLES.MANAGEMENT_ADMIN];
